export const businessLogic = {
  cancellationCutOffMinutes: 20,
  returnCutOffDays: 30,
  loyaltyTiers: {
    1: {
      name: "White",
      lowerBound: 0,
      upperBound: 189.99,
    },
    2: {
      name: "Grey",
      lowerBound: 190,
      upperBound: 379.99,
    },
    3: {
      name: "Black",
      lowerBound: 380,
      upperBound: 570,
    },
  },
  lowStockQuantity: 10,
  signupDelaySeconds: 30,
  maxCartTotalQuantity: null,
  maxCartProductQuantity: null,
  preventSplitCart: true,
  loyaltyPointsConversion: 20,
};

export const regionFeatureToggles = {
  gbp: {
    smsStockNotificationsEnabled: true,
    phoneNumberSignUp: true,
    eddEnabled: false,
    dataCollectionEnabled: true,
  },
  aud: {
    smsStockNotificationsEnabled: true,
    phoneNumberSignUp: true,
    eddEnabled: false,
    dataCollectionEnabled: true,
  },
  usd: {
    smsStockNotificationsEnabled: true,
    phoneNumberSignUp: true,
    eddEnabled: false,
    dataCollectionEnabled: true,
  },
  eur: {
    smsStockNotificationsEnabled: true,
    phoneNumberSignUp: true,
    eddEnabled: false,
    dataCollectionEnabled: true,
  },
};

export const klaviyoLists = {
  gbp: {
    accountId: "KKdVHx",
    listId: "PBQpGD",
  },
  aud: {
    accountId: "QLUUqb",
    listId: "LuKxsY",
  },
  usd: {
    accountId: "LvLjjr",
    listId: "N6CnRv",
  },
  eur: {
    accountId: "Q8ECcx",
    listId: "Jxz7Q4",
  },
};

export const localeUrls = {
  gbp: "ratandboa.com",
  aud: "aus.ratandboa.com",
  usd: "us.ratandboa.com",
  eur: "eur.ratandboa.com",
};

export const bannerContent = {
  gbp: { message: "Free shipping on all orders over £200", color: "black" },
  aud: { message: "Free shipping on all orders to Australia", color: "black" },
  usd: {
    message: "Any order under $800 will not be affected by US tariffs",
    color: "black",
  },
  eur: { message: "Free shipping on all orders over €220", color: "black" },
};

export const signUpBonus = {
  gbp: 20,
  aud: 40,
  usd: 30,
  eur: 20,
};

export const birthdayBonus = {
  gbp: 10,
  aud: 20,
  usd: 15,
  eur: 10,
};

export const shippingRules = {
  gbp: {
    freeAboveAmount: {
      amount: 200,
      currencyCode: "gbp",
    },
  },
  usd: {
    freeAboveAmount: {
      amount: 250,
      currencyCode: "usd",
    },
  },
  aud: {
    freeForCountry: "AU",
    freeAboveAmount: null,
  },
  eur: {
    freeForCountry: null,
    freeAboveAmount: {
      amount: 220,
      currencyCode: "eur",
    },
  },
};

export const paymentMethods = {
  gbp: {
    klarnaEnabled: true,
    clearpayEnabled: true,
  },
  usd: {
    klarnaEnabled: false,
    clearpayEnabled: true,
  },
  aud: {
    klarnaEnabled: false,
    clearpayEnabled: true,
  },
  eur: {
    klarnaEnabled: true,
    clearpayEnabled: false,
  },
};

export const orderCutOffForNextDay = {
  gbp: {
    time: "14:00:00",
    timezone: "Europe/London",
  },
  aud: {
    time: "14:00:00",
    timezone: "Australia/Melbourne",
  },
  usd: {
    time: "14:00:00",
    timezone: "Europe/London",
  },
  eur: {
    time: "14:00:00",
    timezone: "Europe/Amsterdam",
  },
};

export const collectionGateAccessTimes = {
  gbp: {
    level2Plus: "2025-04-01T08:00:00Z",
    level1: "2025-04-01T09:00:00Z",
    disabled: "2025-04-01T10:00:00Z",
  },
  aud: {
    level2Plus: "2025-03-31T20:00:00Z",
    level1: "2025-03-31T21:00:00Z",
    disabled: "2025-03-31T22:00:00Z",
  },
  eur: {
    level2Plus: "2025-04-01T08:00:00Z",
    level1: "2025-04-01T09:00:00Z",
    disabled: "2025-04-01T10:00:00Z",
  },
  usd: {
    level2Plus: "2025-04-01T15:00:00Z",
    level1: "2025-04-01T16:00:00Z",
    disabled: "2025-04-01T17:00:00Z",
  },
};
